import React from "react";
import { Button } from "react-bootstrap";
import { EmptyChemicalRecipesSvg } from "assets/icons/EmptyChemicalRecipesSvg";
import { NO_RECIPES_FOUND } from "configurations/MessageConstants";

const EmptyChemicalRecipes = ({ setShowRecipeForm }) => {
  return (
    <>
      <div className="text-center d-flex flex-column align-items-center my-5">
        <EmptyChemicalRecipesSvg />
        <small className="my-1">{NO_RECIPES_FOUND}</small>
        <Button
          variant="outline-dark"
          size="sm"
          className="rounded-pill mt-2"
          onClick={() => setShowRecipeForm(true)}
        >
          <i className="fa fa-circle-plus me-1"></i>
          Create Recipe
        </Button>
      </div>
    </>
  );
};

export default EmptyChemicalRecipes;
